import { Routes, Route } from 'react-router-dom';
import { Providers } from '@/components/providers';
import { Home } from '@/pages/Home';
import { Login } from '@/pages/Login';
import { Dashboard } from '@/pages/Dashboard';
import { AssessmentTake } from '@/pages/AssessmentTake';
import { BookProgress } from '@/pages/BookProgress';
import { ChapterPage } from '@/pages/ChapterPage';
import { PracticeLab } from '@/pages/PracticeLab';

function App() {
  return (
    <Providers>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/books/:id" element={<BookProgress />} />
        <Route path="/books/:id/chapters/:order" element={<ChapterPage />} />
        <Route path="/assessments/:id/take" element={<AssessmentTake />} />
        <Route path="/practice-labs/:id" element={<PracticeLab />} />
      </Routes>
    </Providers>
  );
}

export default App;
